import React, { useContext } from 'react';

import { UserContext } from '../../../Contexts/UserContext';

import MobileFooter from './MobileFooter';
import WebFooter from './WebFooter/WebFooter';
import { useMediaQuery } from '@material-ui/core';

const Footer = () => {
  const currentUser = useContext(UserContext);
  const isWebSize = useMediaQuery(theme => theme.breakpoints.up('sm'));
  if (isWebSize || !currentUser) {
    return <WebFooter />;
  }
  return <MobileFooter />;
};

export default Footer;
